import { render, staticRenderFns } from "./BoPageTitle.vue?vue&type=template&id=4690d0bb&"
import script from "./BoPageTitle.vue?vue&type=script&lang=js&"
export * from "./BoPageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports